// URL rules for editor links. The dialect is http/https-only (see the
// `isAllowedUri` gate in rich-text-extensions.ts) — both functions here
// enforce the same boundary so a link can never enter the document through
// the dialog or the paste path that the serializer would reject.

import { normalizeUrl } from './detect-urls';

function parsesAsUrl(value: string): boolean {
  try {
    return Boolean(new URL(value));
  } catch {
    return false;
  }
}

/** Normalize member-typed link input (dialog + paste): trim, prepend https://
 *  when scheme-less (LinkedIn behavior), reject non-http schemes. Delegates to
 *  the shared normalizer so the dialog, paste path, and autolink agree. */
export function normalizeLinkUrl(raw: string): string | null {
  return normalizeUrl(raw);
}

/** A paste qualifies for link-over-selection treatment only when the whole
 *  clipboard text is a single explicit http/https URL — the same shape
 *  PostComposer's candidate-URL extraction accepts. Prose containing a URL,
 *  or a bare `example.com`, falls through to the normal paste path. */
export function pastedLinkUrl(text: string): string | null {
  const trimmed = text.trim();
  if (trimmed.length === 0 || /\s/.test(trimmed)) return null;
  if (!/^https?:\/\//i.test(trimmed)) return null;
  return parsesAsUrl(trimmed) ? trimmed : null;
}
